import React from 'react';
import './IgniteSection.css';

function IgniteSection() {
  return (
    <section className="ignite-section">
      <img
        src="/images/OMO-MainBanner-IgnitingCreativityBanner.png"
        alt="Igniting Creativity Banner"
        className="ignite-image"
      />
    </section>
  );
}

export default IgniteSection;